import { Injectable } from '@angular/core';
import {
    HttpRequest, HttpHandler, HttpEvent, HttpInterceptor 
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { getWindow } from 'ssr-window';

@Injectable()
export class HeaderInterceptor implements HttpInterceptor {
    window: Window = getWindow();

    constructor() { }
    intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
        const headers = request.headers.set('X-PLATFORM', 'web')
            .set('X-LOCALE', 'en')
            .set('X-TIMESTAMP', new Date().getTime().toString())
            .set('X-SCREEN-WIDTH', this.window.outerWidth ? this.window.outerWidth.toString() : '')
            .set('X-SCREEN-HEIGHT', this.window.outerHeight ? this.window.outerHeight.toString() : '')
            .set('X-DEVICE-PIXEL-RATIO', this.window.devicePixelRatio ? this.window.devicePixelRatio.toString() : '');

        const clonedRequest = request.clone({
            headers: headers
        });

        return next.handle(clonedRequest);
    }
}
